import { render, staticRenderFns } from "./ReemplazarInscripcionDocumentoPersona.vue?vue&type=template&id=9c7ff402&scoped=true"
import script from "./ReemplazarInscripcionDocumentoPersona.vue?vue&type=script&lang=js"
export * from "./ReemplazarInscripcionDocumentoPersona.vue?vue&type=script&lang=js"
import style0 from "./ReemplazarInscripcionDocumentoPersona.vue?vue&type=style&index=0&id=9c7ff402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7ff402",
  null
  
)

export default component.exports